import { useState } from "react";
import {
  Button,
  Card,
  Form,
  Input,
  Typography,
  Divider,
  App,
  theme,
  Spin,
} from "antd";
import { UserOutlined, LockOutlined, LoginOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useLogin } from "network/queries/user.query";
import { useAuthStore } from "../../auth/useAuthStore";
import { SadHobran } from "../../assets";
import { motion } from "framer-motion";

export default function Login() {
  const { notification, message } = App.useApp();
  const { token } = theme.useToken();
  const navigate = useNavigate();
  const login = useAuthStore((s: any) => s.login);
  const [loading, setLoading] = useState(false);
  const { mutate: userLogin, isLoading } = useLogin();

  const onFinish = async (values: any) => {
    setLoading(true);
    userLogin(values, {
      onSuccess: (data: any) => {
        const { access_token } = data;
        if (!access_token) return;
        localStorage.setItem("TOKEN", access_token);
        login(access_token);
        message.success("تم تسجيل الدخول بنجاح ✅");
        navigate("/");
      },
      onError: (err: any) => {
        const messages = err.response?.data?.message;
        notification.error({
          message: "فشل تسجيل الدخول",
          description: Array.isArray(messages)
            ? messages[0]
            : messages || "تحقق من البيانات المدخلة",
          duration: 2,
        });
      },
      onSettled: () => setLoading(false),
    });
  };

  return (
    <div
      className="flex justify-center items-center min-h-screen w-full bg-gray-600 bg-cover bg-center relative px-4"
      style={{ backgroundImage: `url(${SadHobran})` }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-black/50"></div>

      {/* Animated Card */}
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="relative z-10 w-full max-w-md"
      >
        <Card
          bordered={false}
          className="shadow-2xl rounded-2xl bg-white/90 backdrop-blur-md p-6 md:p-8"
        >
          {/* Header */}
          <div className="text-center mb-6">
            <Typography.Title
              level={3}
              className="!mb-1 text-blue-700 font-extrabold tracking-wide"
            >
              اللجنة الإغاثية في قرية حبران
            </Typography.Title>
            <Typography.Text type="secondary" className="text-gray-600 text-sm">
              نظام إدارة بيانات العائلات
            </Typography.Text>
          </div>

          {/* Login form */}
          <Form
            layout="vertical"
            onFinish={onFinish}
            size="large"
            requiredMark={false}
          >
            <Form.Item
              name="email"
              label="البريد الإلكتروني"
              rules={[
                { required: true, message: "يرجى إدخال البريد الإلكتروني" },
              ]}
            >
              <Input
                prefix={<UserOutlined />}
                placeholder="أدخل البريد الإلكتروني"
                autoComplete="email"
              />
            </Form.Item>

            <Form.Item
              name="password"
              label="كلمة المرور"
              rules={[{ required: true, message: "يرجى إدخال كلمة المرور" }]}
            >
              <Input.Password
                prefix={<LockOutlined />}
                placeholder="أدخل كلمة المرور"
                autoComplete="current-password"
              />
            </Form.Item>

            <Button
              type="primary"
              htmlType="submit"
              icon={<LoginOutlined />}
              block
              loading={isLoading}
              className="mt-2 font-semibold"
              disabled={isLoading}
            >
              {isLoading ? "جاري تسجيل الدخول..." : "دخول"}
            </Button>
          </Form>

          {/* Divider */}
          <Divider className="my-6" />

          {/* Footer */}
          <Typography.Text className="block text-center text-gray-500 text-xs">
            © {new Date().getFullYear()} اللجنة الإغاثية - جميع الحقوق محفوظة
          </Typography.Text>
          <Typography.Text className="block text-center text-gray-500 text-xs">
            Directed By : Wassim Darwish
          </Typography.Text>
        </Card>
      </motion.div>
    </div>
  );
}
